import {gql} from "@apollo/client";
import {mutate, query} from "../../lib/apollo";

export type DemandIo = {
    id: number;
    month: number;
    year: number;
    hpCompanyId: number;
    companyName: string;
    brokerId: number;
    brokerName: string;
    schoolGroupId: number;
    schoolGroupName: string;
    amount: number;
    supplyAmount: number;
};

export async function fetchDemandIos(month: number, year: number): Promise<DemandIo[]> {
    const res = await query(gql`
        query q($month: Int!, $year: Int!) {
            demandIos(month: $month, year: $year) {
                id month year
                hpCompanyId companyName
                brokerId brokerName
                schoolGroupId schoolGroupName
                amount supplyAmount
            }
        }
    `, {month, year});
    return res?.demandIos || [];
}

export type DemandSchool = {id: number; schoolId: number; name: string};

export async function fetchDemandSchools(): Promise<DemandSchool[]> {
    const res = await query(gql`
        query q {
            demandSchoolGroups { id schoolId name }
        }
    `, {});
    return res?.demandSchoolGroups || [];
}

export async function saveDemandIo(input: {
    id?: number | null;
    month: number;
    year: number;
    hpCompanyId: number;
    brokerId: number;
    schoolGroupId: number;
    amount: number;
}) {
    const res = await mutate(gql`
        mutation m($input: DemandIoWrite!) {
            demandIoUpsert(input: $input) { id }
        }
    `, {input});
    return res?.demandIoUpsert;
}

export async function deleteDemandIo(id: number) {
    await mutate(gql`
        mutation m($id: Int!) {
            demandIoDelete(id: $id)
        }
    `, {id});
}
